// extracted by mini-css-extract-plugin
export default {"icons":"FixedIcons_icons__y3co7","icons__whats":"FixedIcons_icons__whats__rihFE","icons__arrow":"FixedIcons_icons__arrow__S72gV"};